export default "/fonts/TiemposHeadline-Medium.ttf?5318f15c1d3735cbccaf0062bcf6b5e7";